import { render } from "./ContactUsThankYou.vue?vue&type=template&id=7b6024c3"
import script from "./ContactUsThankYou.vue?vue&type=script&lang=js"
export * from "./ContactUsThankYou.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__